const sidebarBadges = {
  newBadge: {
    label: 'New update!',
    compactLabel: 'NEW!'
  }
};

export default sidebarBadges;
